export function businessLeadMetaEventId(leadPublicId: string) {
  return `business_lead:${leadPublicId}`;
}

/**
 * Meta CAPI/Pixel matching expects digits with a country code. Local
 * Uruguayan WhatsApp numbers are stored as users type them (099...).
 */
export function normalizeUruguayWhatsapp(value: string): string | undefined {
  const digits = value.replace(/\D/g, "");
  if (digits.length < 6) {
    return undefined;
  }
  if (digits.startsWith("598")) {
    return digits;
  }
  if (digits.startsWith("0")) {
    return `598${digits.slice(1)}`;
  }
  return `598${digits}`;
}
